import { SimpleGrid } from "@chakra-ui/react";
import React from "react";

/**
 * A grid layout used to display three cards. Will stack vertically on mobile and
 * maintain a consistent max-width for those views.
 */
export function ThreeCardGrid({ children }: React.PropsWithChildren) {
  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} gap="5" mt="10" w="100%" maxW={{ base: "md", md: "100%" }} mx="auto">
      {children}
    </SimpleGrid>
  );
}
